module.exports = __webpack_public_path__ + "img/importstep3.f1594e1b.png";